// export const IS_MOBILE = window.innerWidth <= 600;
export const MAIN_TOP_BAR_HEIGHT = 90;
export const RENDERER_TOP_BAR_HEIGHT = 80;
export const IS_MOBILE = ((window.location.href).includes(process.env.REACT_APP_ACERTIA_DOMAIN)) ? (window.innerWidth <= 1024) : window.innerWidth <= 600;
export const HIDE_UPLOAD_BUTTON = (window.location.href).includes(process.env.REACT_APP_FT_SIGN_DOMAIN);
